import React, { useEffect, useState } from "react";
import { Drawer, Button, Form, Input, Select, message } from "antd";
import { UtilisateurService } from "../Services/UtilisateurService";

const { Option } = Select;

const SideBarUser = ({ user, visible, mode, refreshData, closeDrawer }) => {
  const [userRole, setUserRole] = useState([]);
  const [form] = Form.useForm();
  const gestionUsersService = new UtilisateurService();

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const roles = await gestionUsersService.getUserRoles();
        setUserRole(roles);
      } catch (error) {
        console.error("Erreur lors de la récupération des rôles :", error);
      }
    };
    fetchRole();
  }, []);

  useEffect(() => {
    if (user && mode === "edit") {
      form.setFieldsValue({
        ...user,
        profil: user.profil || user.role_name, // Assurez-vous que le champ profil/role_name est bien géré
      });
    } else if (mode === "add") {
      form.setFieldsValue({ pwd_period: "30" });
    } else {
      form.resetFields();
    }
  }, [user, mode, form]);

  const getTitle = () => {
    switch (mode) {
      case "add":
        return "Ajouter un utilisateur";
      case "edit":
        return "Modifier Utilisateur";
      case "changePassword":
        return "Modifier Mot de Passe";
      default:
        return "Gestion des Utilisateurs";
    }
  };

  const onCloseDrawer = () => {
    form.resetFields();
    closeDrawer();
  };

  const onSubmit = async (values) => {
    values.pwd_period = parseInt(values.pwd_period, 10);
    const payload = {
      ...values,
      perim: "IPM",
    };

    // Correction pour le changement de mot de passe
    if (mode === "changePassword") {
      payload.login = user?.login; // Utilise le login du record sélectionné
    }

    try {
      if (mode === "add") {
        await gestionUsersService.addUser(payload);
        message.success("Utilisateur ajouté avec succès");
      } else if (mode === "edit") {
        await gestionUsersService.updateUser(payload);
        message.success("Utilisateur modifié avec succès");
      } else if (mode === "changePassword") {
        await gestionUsersService.updatePassword(payload);
        message.success("Mot de passe modifié avec succès");
      }
      await refreshData();
      onCloseDrawer();
    } catch (error) {
      console.error("Erreur lors de l'opération:", error);
      message.error("Erreur lors de l'opération");
    }
  };

  const validatePassword = (_, value) => {
    if (!value || form.getFieldValue("new_password") === value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Les mots de passe ne correspondent pas!"));
  };

  return (
    <Drawer
      title={getTitle()}
      onClose={onCloseDrawer}
      open={visible}
      width={500}
      maskClosable={false}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        autoComplete="off"
      >
        {mode === "add" && (
          <>
            <Form.Item
              name="login"
              label="Login"
              rules={[{ required: true, message: "Veuillez saisir le login!" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="emailaddress"
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Veuillez saisir un email valide!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="username"
              label="Prénom & Nom"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir le prénom et le nom!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="profil"
              label="Rôle"
              rules={[
                { required: true, message: "Veuillez sélectionner un rôle!" },
              ]}
            >
              <Select showSearch>
                {userRole.map((role) => (
                  <Option key={role.role_code} value={role.profil}>
                    {role.role_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="pwd_period"
              label="Période de validité mot de passe"
              rules={[
                {
                  required: true,
                  message: "Veuillez sélectionner une période!",
                },
              ]}
            >
              <Select>

                <Option value={30}>30 jours</Option>
                <Option value={60}>60 jours</Option>
                <Option value={90}>90 jours</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="etat"
              label="État"
              rules={[
                { required: true, message: "Veuillez sélectionner un état!" },
              ]}
            >
              <Select>
                <Option value={true}>Actif</Option>
                <Option value={false}>Bloqué</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="new_password"
              label="Mot de passe"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir un mot de passe!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="password_confirm"
              label="Confirmation Mot de passe"
              rules={[
                {
                  required: true,
                  message: "Veuillez confirmer le mot de passe!",
                  validateTrigger: "onSubmit",
                  validator: validatePassword,
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </>
        )}
        {mode === "edit" && (
          <>
            <Form.Item
              name="login"
              style={{ display: 'none' }}
            >
              <Input hidden />
            </Form.Item>
            <Form.Item
              name="emailaddress"
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Veuillez saisir un email valide!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="username"
              label="Prénom & Nom"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir le prénom et le nom!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="profil"
              label="Rôle"
              rules={[
                { required: true, message: "Veuillez sélectionner un rôle!" },
              ]}
            >
              <Select showSearch>
                {userRole.map((role) => (
                  <Option key={role.role_code} value={role.profil}>
                    {role.role_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="etat"
              label="État"
              rules={[
                { required: true, message: "Veuillez sélectionner un état!" },
              ]}
            >
              <Select>
                <Option value={true}>Actif</Option>
                <Option value={false}>Bloqué</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="pwd_period"
              label="Période de validité mot de passe"
              rules={[
                {
                  required: true,
                  message: "Veuillez sélectionner une période!",
                },
              ]}
            >
              <Select>
                <Option value={10}>10 jours</Option>
                <Option value={30}>30 jours</Option>
                <Option value={60}>60 jours</Option>
                <Option value={90}>90 jours</Option>
              </Select>
            </Form.Item>
          </>
        )}

        {mode === "changePassword" && (
          <>
            <div className="userInfo">
              <p>
                <strong>Login:</strong> <strong>{user?.login}</strong>
              </p>
              <p>
                <strong>Username:</strong><strong> {user?.username}</strong>
              </p>
            </div>
            <Form.Item
              name="login"
              style={{ display: 'none' }}
            >
              <Input hidden />
            </Form.Item>
            <Form.Item
              name="new_password"
              label="Nouveau Mot de passe"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir un nouveau mot de passe!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="confirm_password"
              label="Confirmer Mot de passe"
              rules={[
                {
                  required: true,
                  message: "Veuillez confirmer le mot de passe!",
                },
                { validator: validatePassword },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </>
        )}
        <Form.Item>
          <Button onClick={onCloseDrawer} style={{ marginRight: 8 }}>
            Annuler
          </Button>
          <Button type="primary" htmlType="submit">
            {mode === "changePassword" || mode === "edit"
              ? "Modifier"
              : "Enregistrer"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SideBarUser;
